//imports
import {
    VIDFLEET_CONFIGURATION_LOAD,
    VIDFLEET_CONFIGURATION_LOAD_RESULT,
    VIDFLEET_CONFIGURATION_SAVE,
    VIDFLEET_CONFIGURATION_SAVE_RESULT,
    VIDFLEET_CONFIGURATION_GET_DEVICE_INFO,
    VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT,
    VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE,
    VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT,
    VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW,
    VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    saveResult: null,
    data: null,
    error: {},
    deviceInfo: {},
    loadingSettingsToClone: false,
    settingsToClone: null,
    openModal: false
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case VIDFLEET_CONFIGURATION_LOAD:
            return { ...state, loading: true, data: null };

        case VIDFLEET_CONFIGURATION_LOAD_RESULT:
            return { ...state, loading: false, data: action.payload };

        case VIDFLEET_CONFIGURATION_SAVE:
            return { ...state, loading: true, saveResult: null };

        case VIDFLEET_CONFIGURATION_SAVE_RESULT:
            return { ...state, loading: false, saveResult: action.payload };

        case VIDFLEET_CONFIGURATION_GET_DEVICE_INFO:
            return { ...state };

        case VIDFLEET_CONFIGURATION_GET_DEVICE_INFO_RESULT:
            return { ...state, deviceInfo: action.payload };

        case VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE:
            return { ...state, loadingSettingsToClone: true, settingsToClone: null };

        case VIDFLEET_CONFIGURATION_SETTINGS_TO_CLONE_RESULT:
            return { ...state, loadingSettingsToClone: false, settingsToClone: action.payload.res };

        case VIDFLEET_CONFIGURATION_BULK_MODAL_SHOW:
            return { ...state, openModal: true };

        case VIDFLEET_CONFIGURATION_BULK_MODAL_HIDE:
            return { ...state, openModal: false };

        case CLEAR_REDUX:
            return ["", "VIDFLEET_CONFIGURATION"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
